module.exports = __webpack_public_path__ + "img/7.dcd23f71.svg";